/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PeopleGroupIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'People Group',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M13.974 6.752a3.947 3.947 0 1 0-.008-5.6 5.872 5.872 0 0 1 .731 2.8 5.886 5.886 0 0 1-.723 2.8Zm3 2.248h-.449a9.833 9.833 0 0 0-1.352.093 6.961 6.961 0 0 1 2.326 5.36v9.412a2.567 2.567 0 0 1-2.562 2.563h-.371l-.818 8.743.032.34a.562.562 0 0 0 .558.489h4.812a.562.562 0 0 0 .558-.489l1.038-11.082h2.192a.563.563 0 0 0 .563-.562v-9.415C23.5 10.813 20.579 9 16.975 9Z"
    />
    <path
      d="M22.474 6.752a3.947 3.947 0 1 0-.008-5.6 5.872 5.872 0 0 1 .731 2.8 5.886 5.886 0 0 1-.723 2.8Zm3 2.248h-.449a9.833 9.833 0 0 0-1.352.093A6.961 6.961 0 0 1 26 14.453v9.412a2.567 2.567 0 0 1-2.562 2.563h-.371l-.818 8.743.032.34a.562.562 0 0 0 .558.489h4.812a.562.562 0 0 0 .558-.489l1.038-11.082h2.192a.563.563 0 0 0 .561-.563v-9.414C32 10.813 29.079 9 25.475 9ZM12.7 3.948A3.948 3.948 0 1 1 8.75 0a3.948 3.948 0 0 1 3.95 3.948ZM8.975 9h-.45C4.921 9 2 10.814 2 14.453v9.413a.562.562 0 0 0 .563.563h2.185L5.78 35.51a.563.563 0 0 0 .558.49h4.812a.562.562 0 0 0 .558-.489l1.038-11.082h2.192a.562.562 0 0 0 .562-.563v-9.413C15.5 10.814 12.579 9 8.975 9Z"
    />
  </svg>`;
};
